import React, { ReactNode } from "react";
import { AllModulesTagName } from "@me-team/common/src/utils/enums";
import { useModulesAccess } from "@me-team/host/src/utils/useModulesAccess";

interface WithModulesAccessProps {
    modules: AllModulesTagName[];
    children: ReactNode;
}

const WithModulesAccess: React.FC<WithModulesAccessProps> = ({ modules, children }) => {
    const hasAccess = useModulesAccess(modules);
    return hasAccess ? <>{children}</> : null;
};

export default WithModulesAccess;
